import { FC, CSSProperties, useState, useEffect } from "react";
import { http } from "../../http";
import { API_BASE_URL } from "Constants";
import {
  AdminPage,
  AdminError,
  Card,
  BRAND_SOFT,
  BORDER,
  MUTED,
  TEXT,
  PictX,
  EmptyState,
} from "./adminShared";

type CouponUsedPageProps = {};

interface CouponUsedResponse {
  result: any[];
}

// 利用時刻を YYYY/MM/DD HH:mm（分まで）で表記する。
const formatUsedAt = (value: string): string => {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}/${p(d.getMonth() + 1)}/${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

const thStyle: CSSProperties = {
  textAlign: "left",
  padding: "14px 18px",
  fontSize: 12,
  fontWeight: 800,
  color: MUTED,
  letterSpacing: "0.06em",
  whiteSpace: "nowrap",
};

const tdStyle: CSSProperties = {
  padding: "14px 18px",
  fontSize: 14,
  color: TEXT,
  borderTop: `1px solid ${BORDER}`,
  verticalAlign: "middle",
};

export const CouponUsedPage: FC<CouponUsedPageProps> = () => {
  const [error, setError] = useState<string>("");
  const [result, setResult] = useState<any[]>([]);
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    getHubs();
  }, []);

  const getHubs = async () => {
    try {
      const response = await http<CouponUsedResponse>(API_BASE_URL + "/sponsor/hubs/coupon/used", "GET");
      const body = response.parsedBody;
      if (!body) {
        setError("response error");
        return;
      }
      setResult(body.result);
    } catch (ex: any) {
      setError(ex.toString());
    } finally {
      setLoaded(true);
    }
  };

  return (
    <AdminPage eyebrow="USAGE" title="クーポン使用状況" icon="ticket" maxWidth={920}>
      <AdminError error={error} />
      {loaded && result.length === 0 ? (
        <EmptyState
          icon="ticket"
          title="まだ利用履歴がありません"
          description="クーポンが使われると、ここに利用状況が表示されます。"
        />
      ) : (
        <Card style={{ overflow: "hidden" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 560 }}>
              <thead style={{ background: BRAND_SOFT }}>
                <tr>
                  <th style={thStyle}>ユーザー</th>
                  <th style={thStyle}>クーポン</th>
                  <th style={thStyle}>店舗QRコード使用</th>
                  <th style={thStyle}>時刻</th>
                </tr>
              </thead>
              <tbody>
                {result.map((r, i) => (
                  <tr key={`${r.name}-${i}`}>
                    <td style={tdStyle}>
                      <img
                        alt=""
                        src={r.profile_image}
                        style={{ width: 40, height: 40, borderRadius: 999, objectFit: "cover", border: `1px solid ${BORDER}` }}
                      />
                    </td>
                    <td style={tdStyle}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <img
                          alt=""
                          src={r.image}
                          style={{ width: 40, height: 40, borderRadius: 10, objectFit: "cover", border: `1px solid ${BORDER}` }}
                        />
                        <span style={{ fontWeight: 600 }}>{r.title}</span>
                      </div>
                    </td>
                    <td style={tdStyle}>
                      {r.from_qr_code ? (
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 5, color: "#0FAC6D", fontWeight: 700 }}>
                          <PictX name="check" size={16} stroke="#0FAC6D" strokeWidth={2} />
                          はい
                        </span>
                      ) : (
                        <span style={{ color: MUTED }}>いいえ</span>
                      )}
                    </td>
                    <td style={{ ...tdStyle, color: MUTED, whiteSpace: "nowrap" }}>{formatUsedAt(r.created)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </AdminPage>
  );
};
